import { render } from "./MoreListItem.vue?vue&type=template&id=24837628"
import script from "./MoreListItem.vue?vue&type=script&lang=js"
export * from "./MoreListItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__